import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useCallback,
  useMemo,
} from "react";

interface LoadingContextType {
  isLoading: boolean;
  onSetLoading: (value: boolean) => void;
}
interface LoadingProviderType {
  children: ReactNode;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
}

export function LoadingProvider({ children }: LoadingProviderType) {
  const [isLoading, setIsLoading] = useState(false);

  const onSetLoading = useCallback((loadingStatus: boolean) => {
    setIsLoading(loadingStatus);
  }, []);

  const contextValue = useMemo(
    () => ({
      isLoading,
      onSetLoading,
    }),
    [isLoading, onSetLoading]
  );

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  );
}
